var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayNoSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 29C27.5899 29 30.5 26.0899 30.5 22.5C30.5 18.9101 27.5899 16 24 16C20.4101 16 17.5 18.9101 17.5 22.5C17.5 26.0899 20.4101 29 24 29Z",
    fill: "#EB1919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0595 39.1481C34.3057 34.8508 29.4864 32 24 32C18.5137 32 13.6944 34.8508 10.9406 39.148C14.4446 42.1716 19.0088 44 24.0001 44C28.9914 44 33.5555 42.1716 37.0595 39.1481Z",
    fill: "#EB1919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43C34.4934 43 43 34.4934 43 24C43 23.077 42.9343 22.1702 42.8075 21.2838L42.5951 19.7989L45.5649 19.3741L45.7773 20.859C45.9241 21.8856 46 22.9344 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C25.0656 2 26.1144 2.07587 27.141 2.22272L28.6259 2.43511L28.2011 5.40489L26.7162 5.19249C25.8298 5.06571 24.923 5 24 5Z",
    fill: "#EB1919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 1.5C42.6944 1.5 46.5 5.30558 46.5 10C46.5 14.6944 42.6944 18.5 38 18.5C33.3056 18.5 29.5 14.6944 29.5 10C29.5 5.30558 33.3056 1.5 38 1.5ZM33 11.5H36.5V15H39.5V11.5H43V8.5H39.5V5H36.5V8.5H33V11.5Z",
    fill: "#EB1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNoSignUp);
export default __webpack_public_path__ + "static/media/play-no-sign-up.8a47f573c2d740abcba5dc2f45df2152.svg";
export { ForwardRef as ReactComponent };